import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';

/**
 * @param {string} id
 * @param {string} name
 * @param   {bool} checked
 * @param {string} label
 * @param {string} description
 */
const StyledNekoSwitch = Styled(props => {
  const { width = '100%', height = '20px', fontSize = '12px', onValue, offValue, checked = false,
    onBackgroundColor, offBackgroundColor, onLabel, offLabel, onChange, disabled, ...rest } = props;

  const onToggle = useCallback((v) => {
    onChange(v.target.checked ? onValue : offValue);
  }, [onChange, onValue, offValue]);

  return (
    <label {...rest} data-is-disabled={disabled ? 'disabled' : ''}>
      <input type="checkbox" onChange={onToggle} checked={checked} disabled={disabled} />
      <span className="nui-switch-slider"></span>
    </label>
  );
})`
  color: ${Theme.white};
  font-family: ${Theme.fontFamily};
  font-size: ${props => props.fontSize};
  position: relative;
  display: inline-block;
  width: ${props => props.width};
  height: ${props => props.height};

  &[data-is-disabled=disabled] {
    opacity: 0.4;

    .nui-switch-slider {
      cursor: auto;
    }
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;
    border: 0;
  }

  .nui-switch-slider {
    background-color: ${props => props.offBackgroundColor};
    border-radius: ${props => props.height};
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: .4s;
  }

  .nui-switch-slider:before {
    border-radius: 50%;
    position: absolute;
    content: "";
    height: ${props => `calc(${props.height} - 8px)`};
    width: ${props => `calc(${props.height} - 8px)`};
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .3s;
  }

  .nui-switch-slider:after {
    content: "${props => props.offLabel}";
    margin-left: auto;
    margin-right: ${props => `calc(${props.height} / 2)`};
  }

  input:checked + .nui-switch-slider {
    background-color: ${props => props.onBackgroundColor};
  }

  input:checked + .nui-switch-slider:before {
    transform: translateX(${props => `calc(${props.width} - ${props.height})` });
  }

  input:checked + .nui-switch-slider:after {
    content: "${props => props.onLabel}";
    margin-left: ${props => `calc(${props.height} / 2)`};
    margin-right: auto;
  }
`;

const NekoSwitch = (props) => {
  return (<StyledNekoSwitch {...props} />);
};

NekoSwitch.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fontSize : PropTypes.string,
  onValue: PropTypes.string,
  offValue: PropTypes.string,
  checked: PropTypes.bool,
  onBackgroundColor: PropTypes.string,
  offBackgroundColor: PropTypes.string,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string
};

NekoSwitch.defaultProps = {
  width: '100%',
  height: '20px',
  fontSize: '12px',
  checked: false
};

export { NekoSwitch };
